// Process-wide singletons: the Dexie db, the HTTP client, the sync engine and
// the local write path. Views import from here; tests build their own.
import { HttpApi } from './db/api'
import { Mutator } from './db/ops'
import { createDb, META } from './db/schema'
import { SyncEngine } from './db/sync'
import { kinds } from './kinds'
import { writeSlug } from './state/scope'

export const db = createDb()
export const api = new HttpApi(
  () => db.getMeta<string>(META.token),
  undefined,
  undefined,
  () => db.getMeta<string>(META.deviceId),
)
export const engine = new SyncEngine(db, api, kinds)
export const mutate = new Mutator(db, kinds, () => engine.schedule(), writeSlug)
